import { LineDrawer } from "./LineDrawer";
export async function loadLineShape(engine, refresh = true) {
    await engine.addShape("line", new LineDrawer(), refresh);
}
